var SupportServiceActionButtonTemplate, SupportServiceActionsBaseView, SupportTrackOrderServiceActionView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportServiceActionsBaseView = require('./service_action_base');

SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache');

SupportTrackOrderServiceActionView = (function(superClass) {
  extend(SupportTrackOrderServiceActionView, superClass);

  function SupportTrackOrderServiceActionView() {
    return SupportTrackOrderServiceActionView.__super__.constructor.apply(this, arguments);
  }

  SupportTrackOrderServiceActionView.prototype.id = 'id_track_order';

  SupportTrackOrderServiceActionView.prototype.events = {
    "click #track_order": "actionHandler"
  };

  SupportTrackOrderServiceActionView.prototype.initialize = function() {
    this.I18nScope = 'modules.support';
    this.template = SupportServiceActionButtonTemplate;
    this.order = Groupon.Support.currentOrder;
    return this.voucher = Groupon.Support.currentOrder.groupons[0];
  };

  SupportTrackOrderServiceActionView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportTrackOrderServiceActionView.prototype.toHash = function() {
    var hash;
    hash = {
      service_action_id: "track_order",
      service_action: I18n.t("js.modules.support.track_order")
    };
    return this.extendHash(hash);
  };

  SupportTrackOrderServiceActionView.prototype.actionHandler = function(event) {
    var url;
    url = Groupon.Support.currentOrder.trackingUrl;
    return window.open(url, '_newtab');
  };

  return SupportTrackOrderServiceActionView;

})(SupportServiceActionsBaseView);

module.exports = SupportTrackOrderServiceActionView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3Mvb3JkZXJfcmVsYXRlZC9zZXJ2aWNlX2FjdGlvbnMvdHJhY2tfb3JkZXJfc2VydmljZV9hY3Rpb24uY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3Mvb3JkZXJfcmVsYXRlZC9zZXJ2aWNlX2FjdGlvbnMvdHJhY2tfb3JkZXJfc2VydmljZV9hY3Rpb24uY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEscUdBQUE7RUFBQTs7O0FBQUEsNkJBQUEsR0FBZ0MsT0FBQSxDQUFRLHVCQUFSOztBQUNoQyxrQ0FBQSxHQUFxQyxPQUFBLENBQVEsaURBQVI7O0FBRS9COzs7Ozs7OytDQUNKLEVBQUEsR0FBSTs7K0NBRUosTUFBQSxHQUNFO0lBQUEsb0JBQUEsRUFBc0IsZUFBdEI7OzsrQ0FFRixVQUFBLEdBQVksU0FBQTtJQUNWLElBQUMsQ0FBQSxTQUFELEdBQWE7SUFDYixJQUFDLENBQUEsUUFBRCxHQUFZO0lBQ1osSUFBQyxDQUFBLEtBQUQsR0FBUyxPQUFPLENBQUMsT0FBTyxDQUFDO1dBQ3pCLElBQUMsQ0FBQSxPQUFELEdBQVcsT0FBTyxDQUFDLE9BQU8sQ0FBQyxZQUFZLENBQUMsUUFBUyxDQUFBLENBQUE7RUFKdkM7OytDQU1aLE1BQUEsR0FBUSxTQUFBO1dBQ04sSUFBQyxDQUFBLEdBQUcsQ0FBQyxNQUFMLENBQVksTUFBQSxDQUFPLElBQUMsQ0FBQSxRQUFSLEVBQWtCLElBQUMsQ0FBQSxNQUFELENBQUEsQ0FBbEIsRUFBNkIsSUFBQyxDQUFBLFNBQTlCLENBQVo7RUFETTs7K0NBR1IsTUFBQSxHQUFRLFNBQUE7QUFDTixRQUFBO0lBQUEsSUFBQSxHQUNFO01BQUEsaUJBQUEsRUFBb0IsYUFBcEI7TUFDQSxjQUFBLEVBQWlCLElBQUksQ0FBQyxDQUFMLENBQU8sZ0NBQVAsQ0FEakI7O1dBRUYsSUFBQyxDQUFBLFVBQUQsQ0FBWSxJQUFaO0VBSk07OytDQU1SLGFBQUEsR0FBZSxTQUFFLEtBQUY7QUFDYixRQUFBO0lBQUEsR0FBQSxHQUFNLE9BQU8sQ0FBQyxPQUFPLENBQUMsWUFBWSxDQUFDO1dBQ25DLE1BQU0sQ0FBQyxJQUFQLENBQVksR0FBWixFQUFpQixTQUFqQjtFQUZhOzs7O0dBckJnQzs7QUF5QmpELE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
